<template>
  <div style="padding-bottom: 30px" class="visual-data-setting">
    <div class="item-row">{{ media_name }}</div>
    <div class="item-row">
      <el-button
        link
        type="primary"
        @click="addDate"
        v-if="operation.add.enable"
      >
        <i class="matrix-icon-calendar"></i>
        <span style="margin-left: 8px; font-size: 12px">Add Date</span>
      </el-button>
    </div>
    <div class="item-row">
      <div
        style="border: 1px solid var(--el-border-color-light); border-bottom: 0"
      >
        <el-table
          :data="datas"
          style="width: 100%"
          header-row-class-name="table-header"
        >
          <el-table-column label="" width="75">
            <template #default="scope">
              <div style="font-size: 16px; color: #979797">
                <div v-if="editIndex == scope.$index">
                  <el-button
                    link
                    style="color: #00bf9a"
                    @click="SaveClick(scope.$index)"
                  >
                    <i class="matrix-icon-save"> </i
                  ></el-button>
                  <el-button
                    link
                    style="margin-left: 7px; color: #eb2810"
                    @click="CloseClick"
                  >
                    <i class="matrix-icon-close"> </i
                  ></el-button>
                </div>
                <div v-else>
                  <el-button
                    link
                    v-if="operation.edit.enable"
                    @click="EditClick(scope.$index, scope.row)"
                    :disabled="operation.edit.disabled"
                  >
                    <i class="matrix-icon-search"> </i
                  ></el-button>

                  <el-button
                    link
                    style="margin-left: 7px"
                    @click="DeleteClick(scope.$index)"
                    :disabled="operation.delete.disabled"
                    v-if="operation.delete.enable"
                    ><el-icon> <Delete /> </el-icon
                  ></el-button>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Visual Date"
            :formatter="Formatter_Cell_Date"
            prop="actual"
          >
            <template #default="scope">
              <div v-if="editIndex == scope.$index">
                <date-picker
                  v-model="visual_date_model"
                  title=""
                  :width="260"
                  :disabled-date="disableDate"
                  value-format="YYYY-MM-DD"
                  :defaultValue="defaultValue"
                >
                </date-picker>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="item-row text-right">
      1-{{ datas.length }} of {{ datas.length }} items
    </div>
  </div>
  <el-dialog
    v-model="addDateDialogShow"
    title=""
    width="500"
    style="
      height: var(--visual-dialog-height);
      background-color: rgba(255, 255, 255, 0.9);
    "
  >
    <div style="margin-top: 113px">
      <date-picker
        v-model="visual_date_model"
        title="Please Select"
        :width="460"
        multipe
        :disabled-date="disableDate"
        value-format="YYYY-MM-DD"
        :defaultValue="new Date(defaultValue)"
      >
        <template #footer>
          <div class="text-right">
            <base-button type="primary" @click="confirmAddDate"
              >Confirm</base-button
            >
            <base-button @click="addDateDialogShow = false">Cancel</base-button>
          </div>
        </template>
      </date-picker>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, watch } from 'vue';
import { Delete } from '@element-plus/icons-vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import datePicker from '@/components/DatePicker';
import { ElMessage, ElMessageBox } from 'element-plus';
import dateJs from '@/assets/js/date.js';
import { formatter_date } from '@/assets/js/formatter.js';
import validationJs from '@/assets/js/validation.js';

var date = ref();
const shortcuts = ref([{ text: 'to be confirmed', value: 'to be confirmed' }]);

const props = defineProps({
  media_name: {
    type: String,
    default: '',
    description: '媒体名称',
  },
  visual_date: {
    type: String,
    default: '',
    description: '上画日期',
  },
  isUpdate: {
    type: Boolean,
    description: '是否更新',
  },
  isInit: {
    type: Boolean,
    description: '是否初始化',
  },
  campaignPeriod: {
    type: Array,
    description: '媒体周期',
  },
  operation: {
    type: [Array],
    description: '操作',
  },
  defaultValue: {
    type: [Date],
    description: '可选，选择器打开时默认显示的时间',
    default: new Date(),
  },
});

const emits = defineEmits(['update']);

const datas = ref([]); // 上画日期数据
const visual_date_model = ref(); // visualsetting日期
const addDateDialogShow = ref(false);
const editIndex = ref(-1);
const addDate = async () => {
  if (!beforeButtonClick()) return;

  addDateDialogShow.value = true;
  visual_date_model.value = [];
};

const beforeButtonClick = () => {
  if (editIndex.value != -1) {
    ElMessage({
      message: 'Please complete previous steps first',
      type: 'warning',
    });
    return false;
  }

  return true;
};

// 上画日期验证
const validator_visualsetting = async () => {
  var source = visual_date_model.value || [];
  if (datas.value.length > 0) {
    source = source.concat(datas.value.map((t) => t.actual));
  }

  const rules = {
    visual_date: [
      {
        message: 'Visual Date(s) cannot be blank.',
        validator(rule, value) {
          return value?.length > 0 && (value?.[0] || '') !== '';
        },
      },
      {
        message: 'Visual Date(s) cannot be duplicated!',
        validator(rule, value) {
          var data = value.filter((t) => t != 'To Be Confirmed');
          return new Set(data).size == data?.length;
        },
      },
    ],
    visual_date_count: {
      message:
        'The number of visual dates cannot exceed the number of campaign days',
      validator(rule, value) {
        var diffDays =
          dateJs.DateDiff(
            props.campaignPeriod?.[0],
            props.campaignPeriod?.[1]
          ) + 1;

        if (isNaN(parseFloat(value))) {
          return false;
        }

        return value <= diffDays;
      },
    },
  };

  var errors = await validationJs
    .validate({ visual_date: source, visual_date_count: source.length }, rules)
    .then((res) => res);

  if (errors?.length > 0) {
    ElMessage({
      message: errors[0].message,
      type: 'warning',
    });
    return false;
  }

  return true;
};

const confirmAddDate = async () => {
  if (!beforeButtonClick()) return;

  var valid = await validator_visualsetting().then((res) => res);
  if (!valid) return;

  datas.value = datas.value.concat(
    visual_date_model.value.map((t) => {
      return { contract: t, actual: t };
    })
  );

  visual_date_model.value = [];
  addDateDialogShow.value = false;
};

// 修改
const EditClick = (index, data) => {
  if (!beforeButtonClick()) return;

  editIndex.value = index;
  visual_date_model.value = data.actual;
};
// 保存
const SaveClick = (index) => {
  if (props.operation.delete?.enable) {
    datas.value[index].contract = visual_date_model.value;
  }
  datas.value[index].actual = visual_date_model.value;

  CloseClick();
};

// 取消
const CloseClick = () => {
  editIndex.value = -1;

  visual_date_model.value = undefined;
};

const DeleteClick = (index) => {
  if (!beforeButtonClick()) return;

  ElMessageBox.confirm(
    'Are you sure to delete this item?',
    'Delete Visual Date',
    {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
    }
  ).then(() => {
    datas.value.splice(index, 1);
  });
};

const Formatter_Cell_Date = (row, column, cellValue, index) => {
  var value = new Date(cellValue);
  if (value == 'Invalid Date') return cellValue;
  return formatter_date(cellValue);
};

/**
 * 禁用日期
 */
const disableDate = (date) => {
  const dayjs = require('dayjs');

  // 周期内的禁用
  if (
    dateJs.DatePickerDisabledDate(
      date,
      dayjs(props.campaignPeriod?.[0]).startOf('d'),
      dayjs(props.campaignPeriod?.[1]).startOf('d')
    )
  ) {
    return true;
  }

  // 已存在的日期

  var exitst_dates = datas.value.filter((t) => t.actual !== 'To Be Confirmed');
  if (exitst_dates?.length > 0) {
    exitst_dates = exitst_dates.map((t) => t.actual);
  }
  if (exitst_dates.includes(dayjs(date).format('YYYY-MM-DD'))) {
    return true;
  }

  return false;
};

watch(
  () => props.isInit,
  (val) => {
    if (val) {
      datas.value = props.visual_date || [];
      editIndex.value = -1;
    }
  },
  {
    immediate: true,
  }
);

watch(
  () => props.isUpdate,
  async (val) => {
    if (val) {
      var new_value = [...datas.value];
      new_value.isUpdate = beforeButtonClick();

      if (new_value.isUpdate) {
        new_value.isUpdate = await validator_visualsetting().then((res) => res);
      }

      emits('update', new_value);
    }
  },
  {
    immediate: true,
  }
);
</script>
<style scoped>
.visual-data-setting {
  color: #423022;
  height: calc(
    var(--visual-dialog-height) - var(--el-dialog-padding-primary) * 3 - 50px -
      30px
  );
  overflow: auto;
}
.visual-data-setting .item-row {
  padding-bottom: 10px;
}
</style>
<style>
.visual-data-setting .table-header th {
  background-color: #e3e3e3 !important;
  color: #66584e;
}
</style>
